import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAcademy'

// CREATORS
export const creatorList = (params = '') => Http.get(`/admin/creators${serialize(params)}`)
export const creatorByID = (params = '') => Http.get(`/admin/creators/${params}`)
export const creatorUpdate = (params = '') => Http.patch(`/admin/creators/${params.id}`, params)
export const creatorToggleActive = (params = '') => Http.patch(`/admin/creators/${params}/toggle-active`)

// Aliases used by the incoming academy branch
export const listCreators = (params) => Http.get('/admin/creators', { params })
export const getCreator = (id) => Http.get(`/admin/creators/${id}`)
export const updateCreator = ({ id, ...data }) => Http.patch(`/admin/creators/${id}`, data)
export const toggleCreatorActive = (id) => Http.patch(`/admin/creators/${id}/toggle-active`)

// CREATOR APPLICATIONS
export const applicationList = (params = '') => Http.get(`/admin/creator-applications${serialize(params)}`)
export const applicationByID = (params = '') => Http.get(`/admin/creator-applications/${params}`)
export const applicationApprove = (id, data = {}) => Http.patch(`/admin/creator-applications/${id}/approve`, data)
export const applicationReject = (id, data = {}) => Http.patch(`/admin/creator-applications/${id}/reject`, data)
export const applicationCredentialsDocument = (id) => Http.get(`/admin/creator-applications/${id}/credentials-document`)

// BOOKINGS
export const bookingList = (params = '') => Http.get(`/admin/bookings${serialize(params)}`)
export const bookingByID = (params = '') => Http.get(`/admin/bookings/${params}`)
